/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { memo, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import useOnClickOutside from '../../../components/hooks/useOnClickOutside';
import arrow from '../../../assets/images/arrow-right-black.svg';

const MultiOptionsSelector = ({ checkboxOptions = [], onChange, readOnly, fieldLabel }) => {
	const containerRef = useRef(null);

	const [isOpen, setIsOpen] = useState(false);

	const optionsSelected = checkboxOptions.filter((option) => option.checked);
	const allOptionsSelected = optionsSelected.length === checkboxOptions.length;

	const onSelectAll = () => {
		const updatedOptions = checkboxOptions.map((option) => ({ ...option, checked: !allOptionsSelected }));
		onChange(updatedOptions);
	};

	const onCheckboxChange = (value) => {
		const updatedOptions = checkboxOptions.map((option) => {
			if (option.value === value) {
				return { ...option, checked: !option.checked };
			}
			return option;
		});
		onChange(updatedOptions);
	};

	const label = useMemo(() => {
		if (allOptionsSelected) {
			return `All ${fieldLabel} (${checkboxOptions.length})`;
		}
		if (optionsSelected.length === 1) {
			return optionsSelected[0].label;
		}
		if (!optionsSelected.length) {
			return `Select ${fieldLabel}...`;
		}
		return `Multiple ${fieldLabel} (${optionsSelected.length})`;
	}, [allOptionsSelected, checkboxOptions.length, fieldLabel, optionsSelected]);

	useOnClickOutside(containerRef, () => setIsOpen(false), 'mousedown');

	return (
		<div className="multi-select-container" ref={containerRef}>
			<button
				className={classNames('button', { active: isOpen, disabled: !checkboxOptions?.length })}
				type="button"
				onClick={() => setIsOpen(!isOpen)}
			>
				<span>{label}</span>
				<img src={arrow} alt="Toggle dropdown" className="dropdown-arrow" />
			</button>

			{isOpen && (
				<div className="content">
					<div className={classNames('checkbox-section', { deactivated: readOnly })}>
						<div className="checkbox-item select-all">
							<input
								type="checkbox"
								id="select-all-checkbox"
								value={allOptionsSelected}
								checked={allOptionsSelected}
								onChange={onSelectAll}
							/>
							<label className="checkbox-item-label" htmlFor="select-all-checkbox">
								All {fieldLabel}
							</label>
						</div>
						{checkboxOptions.map((option) => (
							<div className="checkbox-item" key={option.value}>
								<input
									type="checkbox"
									id={option.label}
									value={option.checked}
									checked={option.checked}
									onChange={() => onCheckboxChange(option.value)}
								/>
								<label className="checkbox-item-label" htmlFor={option.label}>
									{option.label}
								</label>
							</div>
						))}
					</div>
				</div>
			)}
		</div>
	);
};

export default memo(MultiOptionsSelector);
